import { render } from "./AdminSettingFeesAndTaxes.vue?vue&type=template&id=2e7f8b22&scoped=true"
import script from "./AdminSettingFeesAndTaxes.vue?vue&type=script&lang=js"
export * from "./AdminSettingFeesAndTaxes.vue?vue&type=script&lang=js"

import "./AdminSettingFeesAndTaxes.vue?vue&type=style&index=0&id=2e7f8b22&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7f8b22"]])

export default __exports__